import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { CountersService } from '../lib/counters.service'

export const COUNTERS_HISTORY_RQ_KEY = 'counter-history'

export const useCounterHistory = (id: string) => {
  const { status, data, error, isLoading, isFetching, isError } = useQuery({
    queryKey: [COUNTERS_HISTORY_RQ_KEY, id],
    queryFn: () => CountersService.getHistory(id),
    placeholderData: keepPreviousData,
    enabled: Boolean(id)
  })

  return {
    data,
    error,
    isError,
    isLoading,
    isFetching,
    status
  }
}
